export const SupportedLanguages = {
  English: "en-US",
  Hindi: "hi",
  EnglishLanguage: "English",
};
